/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_YoutubeInputs */

const en_us2_onboarding_how_heard_youtube = /** @type {(inputs: Onboarding_How_Heard_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const pt_br2_onboarding_how_heard_youtube = /** @type {(inputs: Onboarding_How_Heard_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const es_419_onboarding_how_heard_youtube = /** @type {(inputs: Onboarding_How_Heard_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const pt_pt2_onboarding_how_heard_youtube = /** @type {(inputs: Onboarding_How_Heard_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const fr_fr2_onboarding_how_heard_youtube = /** @type {(inputs: Onboarding_How_Heard_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const de_de2_onboarding_how_heard_youtube = /** @type {(inputs: Onboarding_How_Heard_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const it_it2_onboarding_how_heard_youtube = /** @type {(inputs: Onboarding_How_Heard_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

/**
* | output |
* | --- |
* | "YouTube" |
*
* @param {Onboarding_How_Heard_YoutubeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_youtube = /** @type {((inputs?: Onboarding_How_Heard_YoutubeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_YoutubeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_youtube(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_youtube(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_youtube(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_youtube(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_youtube(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_youtube(inputs)
	return en_us2_onboarding_how_heard_youtube(inputs)
});
export { onboarding_how_heard_youtube as "onboarding.how_heard.youtube" }